import React, {useEffect, useState} from "react";
import PageHeaderLayout from "../../layout/pageHeaderLayout";
import {Button, Card, Col, Divider, Form, Input, Menu, Popconfirm, Row, Space} from "antd";
import StandardTable, {StandardColumnsType} from "../../components/StandardTable";
import * as api from "../../apis/news";
import {useRequest} from "ahooks";
import useAntTable from "../../utils/useAntTable";
import WithAuth from "../../utils/withAuth";
import ModifyModal from "./modifyModal";
import useFormModal from "../../utils/useFormModal";
import Moment from "moment/moment";
import {ArrowLeftOutlined} from "@ant-design/icons";

const AddButton = WithAuth('add', Button)
const DeletePopconfirm = WithAuth('delete', Popconfirm)

function News() {

    const [form] = Form.useForm()
    const [queryParams, setQueryParams] = useState<any>({title: undefined, classification: 'all'})
    const [selectedNews, setSelectedNews] = useState<any>()

    const {modalProps, setVisible} = useFormModal({
        onRequest: addNews,
        onOk: () => {
            refresh()
            setVisible(false)
        }
    })

    const {data: classifications = []} = useRequest(api.getAllNewsClassifications, {
        formatResult: res => res.data.data,
    })

    const {tableProps, refresh} = useAntTable(api.getNews, {
        extraParams: {
            ...queryParams,
            classification: queryParams.classification === 'all' ? null : queryParams.classification
        }
    })

    async function addNews(data: any) {
        const content = data.contentRaw
        data.content = content.toHTML()
        data.contentRaw = content.toRAW()
        return api.addNews(data)
    }

    const {run: onDelete} = useRequest(api.deleteNews, {
        manual: true,
        onSuccess: () => refresh()
    })

    useEffect(() => {
        refresh()
    }, [queryParams]);

    const columns: StandardColumnsType = [
        {
            dataIndex: 'title',
            title: 'Title',
            render: (value, record: any) => <a onClick={() => setSelectedNews(record)}>{value}</a>
        },
        {
            dataIndex: 'classification',
            title: 'Classification',
        },
        {
            dataIndex: 'createName',
            title: 'Create by',
        },
        {
            dataIndex: 'createTime',
            title: 'Create time',
            render: (value) => Moment(value).format('lll'),
        },
        {
            dataIndex: 'operations',
            title: 'Operations',
            render: (_, record: any) => (
                <span>
                    <DeletePopconfirm title={'Are you sure?'} onConfirm={() => onDelete(record.id)}>
                        <a>Delete</a>
                    </DeletePopconfirm>
                </span>
            )
        }
    ]

    return (
        <PageHeaderLayout>
            <Card>
                <Form labelCol={{span: 8}}
                      wrapperCol={{span: 16}}
                      form={form}
                      onFinish={values => setQueryParams({...queryParams, ...values})}
                >
                    <Row style={{width: '100%'}}>
                        <Col span={6} className={'SearchBar-Col LastRow'}>
                            <Form.Item name={'title'} label={'Title'}>
                                <Input/>
                            </Form.Item>
                        </Col>
                        <Col offset={11} span={6} style={{textAlign: "right"}} className={'SearchBar-Col LastRow'}>
                            <Space>
                                <Button onClick={() => form.resetFields()}>Reset</Button>
                                <Button type={'primary'} onClick={() => form.submit()}>Search</Button>
                            </Space>
                        </Col>
                    </Row>
                </Form>
            </Card>
            <div style={{display: 'flex', marginTop: 15}}>
                <div style={{marginRight: 15}}>
                    <AddButton style={{marginBottom: 15}} block type={'primary'} onClick={() => setVisible(true)}>Release
                        News</AddButton>
                    <Card style={{width: 300}}>
                        <Menu selectedKeys={[queryParams.classification]}
                              onSelect={item => {
                                  setQueryParams({...queryParams, classification: item.key})
                                  setSelectedNews(undefined)
                              }}>
                            <Menu.Item key={'all'}>All</Menu.Item>
                            {classifications.map((item: any) => (
                                <Menu.Item key={item.id}>{item.name}</Menu.Item>
                            ))}
                        </Menu>
                    </Card>
                </div>
                <div style={{flex: 1}}>
                    {!selectedNews ? (
                        <StandardTable rowKey={'id'} columns={columns} {...tableProps} />
                    ) : (
                        <Card style={{width: '100%'}}
                              title={(
                                  <div>
                                      <ArrowLeftOutlined onClick={() => setSelectedNews(undefined)}/>
                                      <span style={{marginLeft: 15}}>{selectedNews.title}</span>
                                  </div>
                              )}
                              extra={(
                                  <span>
                                      <span>{selectedNews.classification}</span>
                                      <Divider type={'vertical'}/>
                                      <span>{selectedNews.createName}</span>
                                      <Divider type={'vertical'}/>
                                      <span>{Moment(selectedNews.createTime).format('lll')}</span>
                                  </span>
                              )}
                        >
                            <div dangerouslySetInnerHTML={{__html: selectedNews.content}}/>
                        </Card>
                    )}
                </div>
            </div>
            <ModifyModal {...modalProps}/>
        </PageHeaderLayout>
    )
}

export default News;
